import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';

import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';

import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MoreIcon from '@material-ui/icons/MoreVert';

import TransmuteLogo from "./../Logo/logo-transmute.svg";

const drawerWidth = 0;

const useStyles = makeStyles(theme => ({
  root: {
    // display: 'flex',
  },
  grow: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },

  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  content: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth,
    },

    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function ResponsiveDrawer(props) {
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={'primary-search-account-menu'}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {props.rightHandAccountMenu.map(menuItem => {
        if (!menuItem.displaySmUp) {
          return (
            <MenuItem key={menuItem.label} onClick={menuItem.onClick}>
              {menuItem.label}
            </MenuItem>
          );
        }
        return '';
      })}
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={'primary-search-account-menu-mobile'}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {props.rightHandAccountMenu.map(i => {
        return (
          <MenuItem key={i.label} onClick={i.onClick}>
            <IconButton aria-label={i.ariaLabel} color="inherit">
              <Badge badgeContent={i.badgeContent} color="secondary">
                {i.icon}
              </Badge>
            </IconButton>
            <p>{i.label}</p>
          </MenuItem>
        );
      })}
    </Menu>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton> */}
          {props.headerImage ? (
            <img
              src={props.headerImage}
              alt={props.headerText}
              className={classes.title}
              style={{ height: '28px' }}
            />
          ) : (
              <Typography className={classes.title} variant="h6" noWrap>
                {props.headerText}
              </Typography>
            )}
          <div className={classes.grow} />
          {/* <div className={classes.sectionDesktop}>
            {props.rightHandAccountMenu.map(menuItem => {
              if (menuItem.displaySmUp) {
                return (
                  <IconButton
                    key={menuItem.ariaLabel}
                    aria-label={menuItem.ariaLabel}
                    color="inherit"
                  >
                    <Badge
                      color="secondary"
                      badgeContent={menuItem.badgeContent}
                    >
                      {menuItem.icon}
                    </Badge>
                  </IconButton>
                );
              }
              return '';
            })}

            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={'primary-search-account-menu'}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircleIcon />
            </IconButton>
          </div> */}
          {/* <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={'primary-search-account-menu-mobile'}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div> */}
        </Toolbar>
      </AppBar>
      {/* {renderMobileMenu}
      {renderMenu} */}

      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div style={{ maxWidth: '100%' }}>{props.content}</div>
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  rightHandAccountMenu: PropTypes.any,
  content: PropTypes.any,
  drawer: PropTypes.any,
  headerImage: PropTypes.string,
  headerText: PropTypes.string,
  container: PropTypes.any,
};

export default ResponsiveDrawer;
